export const messages = {
  en: {
    hireParkingSpace: {
      title: 'Add Vehicle',
      carNum: 'License Plate',
      carNumPlaceholder: 'Required, please enter license plate',
      carBrand: 'Car Brand',
      carBrandPlaceholder: 'Optional, please enter car brand',
      carType: 'Vehicle Type',
      carTypePlaceholder: 'Required, please select vehicle type',
      carColor: 'Color',
      carColorPlaceholder: 'Optional, please enter color',
      licenseType: 'License Type',
      licenseTypePlaceholder: 'Required, please select license type',
      monthlyRent: 'Monthly Rent',
      saleCar: 'For Sale',
      internalCar: 'Internal Vehicle',
      freeCar: 'Free Vehicle',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please select start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please select end time',
      owner: 'Owner',
      ownerPlaceholder: 'Required, please select owner',
      parkingArea: 'Parking Area',
      parkingAreaPlaceholder: 'Required, please select parking area',
      parkingSpace: 'Parking Space',
      parkingSpacePlaceholder: 'Optional, please select parking space',
      contact: 'Contact Person',
      contactPlaceholder: 'Optional, defaults to owner name',
      tel: 'Contact Phone',
      telPlaceholder: 'Optional, defaults to owner phone',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      validate: {
        carNum: 'License plate is required',
        carType: 'Vehicle type is required',
        licenseType: 'License type is required',
        owner: 'Owner is required',
        parkingArea: 'Parking area is required',
        parkingAreaMismatch: 'Selected parking space does not belong to the selected parking area',
        parkingSpace: 'Parking space is required',
        tel: 'Incorrect contact phone format',
        dateRange: 'Date range is required',
        startTime:'start time is required',
        endTime:'end time is required'

      },
      saveSuccess: 'Vehicle information saved successfully!',
      saveError: 'Failed to save vehicle information'
    },
    searchParkingSpace: {
      title: 'Select Parking Space',
      parkingAreaPlaceholder: 'Select parking area',
      numPlaceholder: 'Enter parking space number',
      areaNum: 'Parking Area',
      num: 'Parking Space',
      type: 'Type',
      ground: 'Ground',
      underground: 'Underground',
      parkingType: 'Parking Type',
      state: 'State',
      area: 'Area',
      loadError: 'Failed to load parking space information'
    }
  },
  zh: {
    hireParkingSpace: {
      title: '添加车辆',
      carNum: '车牌号',
      carNumPlaceholder: '必填，请填写车牌号',
      carBrand: '汽车品牌',
      carBrandPlaceholder: '选填，请填写汽车品牌',
      carType: '车类型',
      carTypePlaceholder: '必填，请选择车辆类型',
      carColor: '颜色',
      carColorPlaceholder: '选填，请填写颜色',
      licenseType: '车牌类型',
      licenseTypePlaceholder: '必填，请选择车牌类型',
      monthlyRent: '月租车',
      saleCar: '出售车辆',
      internalCar: '内部车',
      freeCar: '免费车',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请填写开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请填写结束时间',
      owner: '业主',
      ownerPlaceholder: '必填，请选择业主',
      parkingArea: '停车场',
      parkingAreaPlaceholder: '必填，请选择停车场',
      parkingSpace: '车位',
      parkingSpacePlaceholder: '选填，请选择车位',
      contact: '联系人',
      contactPlaceholder: '选填，默认业主姓名',
      tel: '联系电话',
      telPlaceholder: '选填，默认业主电话',
      remark: '备注',
      remarkPlaceholder: '选填，请填写备注',
      validate: {
        carNum: '车牌号不能为空',
        carType: '车类型不能为空',
        licenseType: '车牌类型不能为空',
        owner: '业主不能为空',
        parkingArea: '停车场不能为空',
        parkingAreaMismatch: '所选车位不属于所选停车场',
        parkingSpace: '车位不能为空',
        tel: '联系电话格式不正确',
        dateRange: '请选择日期范围',
        startTime:'开始时间不能为空',
        endTime:'结束时间不能为空'
      },
      saveSuccess: '车辆信息保存成功！',
      saveError: '车辆信息保存失败'
    },
    searchParkingSpace: {
      title: '选择停车位',
      parkingAreaPlaceholder: '请选择停车场',
      numPlaceholder: '请输入停车位编号',
      areaNum: '停车场编码',
      num: '停车位编码',
      type: '停车场类型',
      ground: '地上停车位',
      underground: '地下停车位',
      parkingType: '车位类型',
      state: '车位状态',
      area: '面积',
loadError: '加载停车位信息失败'
    }
  },
  'zh-TW': {
    hireParkingSpace: {
      title: '添加車輛',
      carNum: '車牌號',
      carNumPlaceholder: '必填，請填寫車牌號',
      carBrand: '汽車品牌',
      carBrandPlaceholder: '選填，請填寫汽車品牌',
      carType: '車類型',
      carTypePlaceholder: '必填，請選擇車輛類型',
      carColor: '顏色',
      carColorPlaceholder: '選填，請填寫顏色',
      licenseType: '車牌類型',
      licenseTypePlaceholder: '必填，請選擇車牌類型',
      monthlyRent: '月租車',
      saleCar: '出售車輛',
      internalCar: '內部車',
      freeCar: '免費車',
      startTime: '開始時間',
      startTimePlaceholder: '必填，請填寫開始時間',
      endTime: '結束時間',
      endTimePlaceholder: '必填，請填寫結束時間',
      owner: '業主',
      ownerPlaceholder: '必填，請選擇業主',
      parkingArea: '停車場',
      parkingAreaPlaceholder: '必填，請選擇停車場',
      parkingSpace: '車位',
      parkingSpacePlaceholder: '選填，請選擇車位',
      contact: '聯絡人',
      contactPlaceholder: '選填，默認業主姓名',
      tel: '聯絡電話',
      telPlaceholder: '選填，默認業主電話',
      remark: '備註',
      remarkPlaceholder: '選填，請填寫備註',
      validate: {
        carNum: '車牌號不能為空',
        carType: '車類型不能為空',
        licenseType: '車牌類型不能為空',
        owner: '業主不能為空',
        parkingArea: '停車場不能為空',
        parkingAreaMismatch: '所選車位不屬於所選停車場',
        parkingSpace: '車位不能為空',
        tel: '聯絡電話格式不正確',
        dateRange: '請選擇日期範圍',
        startTime:'開始時間不能為空',
        endTime:'結束時間不能為空'
      },
      saveSuccess: '車輛信息保存成功！',
      saveError: '車輛信息保存失敗'
    },
    searchParkingSpace: {
      title: '選擇停車位',
      parkingAreaPlaceholder: '請選擇停車場',
      numPlaceholder: '請輸入停車位編號',
      areaNum: '停車場編碼',
      num: '停車位編碼',
      type: '停車場類型',
      ground: '地上停車位',
      underground: '地下停車位',
      parkingType: '車位類型',
      state: '車位狀態',
      area: '面積',
      loadError: '加載停車位信息失敗'
    }
  }
}